import React from 'react';
import Modal from 'react-modal';
import './DeleteConfirmModal.css';

// Set app element for accessibility
if (typeof window !== 'undefined') {
  Modal.setAppElement('#root');
}

function DeleteConfirmModal({ isOpen, onClose, onConfirm, message, user }) {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const formatTime = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(parseFloat(timestamp) * 1000);
    return date.toLocaleString('en-US', { 
      month: 'short',
      day: 'numeric',
      hour: '2-digit', 
      minute: '2-digit' 
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="delete-modal"
      overlayClassName="delete-modal-overlay"
      closeTimeoutMS={200}
    >
      <div className="delete-modal-header">
        <h3>Delete message</h3>
        <button className="delete-modal-close" onClick={onClose}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </button>
      </div>
      
      <div className="delete-modal-body">
        <p className="delete-modal-warning">
          Are you sure you want to delete this message? This cannot be undone.
        </p>
        
        {message && (
          <div className="delete-message-preview">
            <div className="delete-preview-header">
              <div className="delete-preview-avatar">
                {user?.profile?.image_48 ? (
                  <img src={user.profile.image_48} alt={user?.real_name || 'User'} />
                ) : (
                  <div className="delete-avatar-placeholder">
                    {user?.real_name?.charAt(0) || user?.name?.charAt(0) || '?'}
                  </div>
                )}
              </div>
              <div className="delete-preview-info">
                <div className="delete-preview-author">
                  {user?.real_name || user?.name || 'Unknown User'}
                </div>
                <div className="delete-preview-time">
                  {formatTime(message.ts)}
                </div>
              </div>
            </div>
            <div className="delete-preview-text">
              {message.text && message.text.length > 200 
                ? message.text.substring(0, 200) + '...' 
                : message.text}
            </div>
          </div>
        )}
      </div>
      
      <div className="delete-modal-footer">
        <button className="delete-modal-button delete-modal-cancel" onClick={onClose}>
          Cancel
        </button>
        <button className="delete-modal-button delete-modal-confirm" onClick={handleConfirm}>
          Delete message
        </button>
      </div>
    </Modal>
  );
}

export default DeleteConfirmModal;